import React from 'react';
import { Toaster } from 'react-hot-toast';

import ErrorBoundary from './components/ErrorBoundary';
import AppProvider from './hooks';
import AppRoutes from './routes';
import GlobalStyle from './styles/global';

function App() {
  return (
    <AppProvider>
      <ErrorBoundary fallback={null}>
        <Toaster position="top-right" reverseOrder={false} />
        <AppRoutes />
      </ErrorBoundary>
      <GlobalStyle />
    </AppProvider>
  );
}

export default App;
